import React, { useState, useEffect } from "react";
import { Card, Form, Row, Col, Button, Table, Modal } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";


const BASE_URL = "https://sutmmgdev.codydeasoftech.in/api";

const ItemMaster = () => {
  const [loading, setLoading] = useState(false);
  const [genderList, setGenderList] = useState([]);
  const [filters, setFilters] = useState({ gender_id: "", });
  const [items, setItems] = useState([]);

  const navigate = useNavigate();

const fetchItems = async () => {
  setLoading(true);
  try {
    const token = localStorage.getItem("token");

    const res = await axios.post(`${BASE_URL}/itemsList`,
     {
        gender_id: filters.gender_id
    },{

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    setItems(res.data.data.itemsList || []);
  } catch (error) {
    console.error("Fetch Items Error:", error);

    if (error.response?.status === 401) {
      Swal.fire("Session Expired", "Please login again", "warning");
      localStorage.clear();
      navigate("/suda/login");
    }
  } finally {
    setLoading(false);
  }
};


 const fetchGenderList = async() => {
    try{
const token = localStorage.getItem("token");

    const res = await axios.get(`${BASE_URL}/genderList`,
     {

      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
        setGenderList(res.data.data.genderList || []);

    }catch(err){
        console.log(err);
    }
 }


  useEffect(() => {
    fetchItems();
    fetchGenderList();
  }, []);

  return (
    <div className="container mt-4" style={{ maxWidth: 1300 }}>
       <Card
        className="mb-4 border-0"
        style={{
          background: "linear-gradient(135deg, #E3F2FD, #ffffff)",
          borderRadius: "14px",
          boxShadow: "0 8px 25px rgba(21,101,193,0.15)",
        }}
      >
        <div
          className="px-4 py-3 text-white rounded-top"
          style={{
            background: "linear-gradient(90deg, #0D47A1, #1565C1)",
          }}
        >
          <h5 className="mb-0 fw-bold d-flex align-items-center gap-2">
            <i className="fa-solid fa-filter"></i> Item Master
          </h5>
        </div>

        <Card.Body className="px-4 py-4">
            <Row className="align-items-center">
                <Col md={4}>
                    <Form.Group className="mb-3">
                        <Form.Label>Gender</Form.Label>
                        <Form.Select
                        value={filters.gender_id}
                        onChange={(e) =>
                            setFilters({ ...filters, gender_id: e.target.value })
                        }
                        style={{
                            borderRadius: "10px",
                            border: "2px solid #1565C1",
                        }}
                        >
                        <option value="">All Genders</option>
                        {genderList.map((g) => (
                            <option key={g.id} value={g.id}>
                            {g.name}
                            </option>
                        ))}
                        </Form.Select>
                    </Form.Group>
                </Col>


                <Col md={4} className="d-flex gap-3 mt-3">
                  {/* SEARCH */}
                  <Button
                    className="w-50 fw-semibold text-white"
                    style={{
                      background: "#1565C1",
                      border: "none",
                      borderRadius: "10px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#0D47A1")}
                    onMouseLeave={(e) => (e.target.style.background = "#1565C1")}
                    onClick={fetchItems}
                  >
                    <i className="fa-solid fa-magnifying-glass me-2"></i> Search
                  </Button>

                  {/* RESET */}
                  <Button
                    className="w-50 fw-semibold text-white"
                    style={{
                      background: "#E53935",
                      border: "none",
                      borderRadius: "10px",
                      transition: "0.3s",
                    }}
                    onMouseEnter={(e) => (e.target.style.background = "#D32F2F")}
                    onMouseLeave={(e) => (e.target.style.background = "#E53935")}
                    onClick={() => {
                      setFilters({ searchText: "" });
                      fetchItems();
                    }}
                  >
                    <i className="fa-solid fa-arrow-rotate-left me-2"></i> Reset
                  </Button>
                </Col>
            </Row>
        </Card.Body>
      </Card>



        {loading && (
        <div className="loader-wrapper">
            <div className="blue-spinner"></div>

            <div className="loading-line">
            <div className="loading-progress"></div>
            </div>

            <p className="loading-text">Loading, please wait...</p>
        </div>
        )}
      {/* 📄 TABLE */}
      {!loading && (

      <Card className="mb-4 border-0"
              style={{
                  background: "linear-gradient(145deg, #E3F2FD, #ffffff)",
                  boxShadow: "0 10px 35px rgba(21,101,193,0.18)",
                  overflow: "hidden",
              }}>
              <Table bordered hover responsive striped>
          <thead className="text-white">
            <tr>
              <th style={{
        padding: "5px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        borderTopLeftRadius: "10px",
        backgroundColor: "#edf7fe",
        height: "10px",
        borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign:"center"


      }}>SL No.</th>
              <th style={{
        padding: "5px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        borderTopLeftRadius: "10px",
        backgroundColor: "#edf7fe",
        height: "10px",
        borderBottom: "1px solid black",
                borderTop: "1px solid black",
                textAlign:"center"


      }}>Item Name</th>
              <th style={{
        padding: "5px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        borderTopLeftRadius: "10px",
        backgroundColor: "#edf7fe",
        height: "10px",
        borderBottom: "1px solid black",
        borderTop: "1px solid black",
        textAlign:"center"


      }}>Quantity</th>

            </tr>
          </thead>

          <tbody>
            {items.length > 0 ? (
              items.map((row, index) => (
                <tr key={row.id}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{row.item_name}</td>
                  <td className="text-center">{row.default_quantity}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="4" className="text-center text-muted py-4">
                  No Data Found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </Card>
      )}


    </div>
  );
};

export default ItemMaster;
